import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { PortalBaseService } from 'src/portal/portal-base.service';
import { PortalTeamsModel } from './portal-teams.models';

@Injectable({
  providedIn: 'root'
})
export class PortalTeamsService extends PortalBaseService {
  public getMyTeams(): Promise<PortalTeamsModel> {
    return lastValueFrom(this.get<PortalTeamsModel>('portal/teams'));
  }
}
